import { View, StyleSheet } from 'react-native';
import { Text, theme } from '@socrait/react';

import { HyperLink } from '~/components/HyperLink';
import { handleTermsOfServicePress } from '~/constants';

export function TosCheckboxLabel() {
  return (
    <View style={styles.container}>
      <Text style={styles.text}>I agree to the </Text>
      <HyperLink onPress={handleTermsOfServicePress} style={styles.text}>
        Terms of Service
        <Text style={[styles.text, { color: theme.colors.red }]}>*</Text>
      </HyperLink>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: theme.spacing.xsmall,
  },
  text: {
    fontSize: theme.fontSizes.small,
    lineHeight: theme.lineHeights.regular,
  },
});
